import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';
import { AppToastContainer } from 'Application/components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ThemeCustomization from 'themes';
import './index.css';

// auth provider
import { JWTProvider } from 'contexts/JWTContext';
import NavigationScroll from 'layout/NavigationScroll';
import { useEffect } from 'react';
import { getUserDataFromStorage } from 'Application/utils';
import { useAuth } from 'Application/context/AuthContext';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
    const userData = getUserDataFromStorage();
    const { toggleRefresh } = useAuth();

    useEffect(() => {
        if (userData) {
            toggleRefresh(true); // Auto-refresh auth token
        } else {
            toggleRefresh(false); // Stop auto-refreshing auth token
        }
    }, []);

    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeCustomization>
                <RTLLayout>
                    <Locales>
                        <NavigationScroll>
                            <AppToastContainer />
                            <JWTProvider>
                                <>
                                    <Notistack>
                                        <RouterProvider router={router} />
                                        <Snackbar />
                                    </Notistack>
                                </>
                            </JWTProvider>
                        </NavigationScroll>
                    </Locales>
                </RTLLayout>
            </ThemeCustomization>
        </QueryClientProvider>
    );
};

export default App;
